import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=dd134226&scoped=true&"
import script from "./policy.vue?vue&type=script&lang=js&"
export * from "./policy.vue?vue&type=script&lang=js&"
import style0 from "./policy.vue?vue&type=style&index=0&id=dd134226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd134226",
  null
  
)

export default component.exports